import ROUTES from '../routes';
import ExportPage from '../hoc/export/export';
import ExportBanks from '../hoc/export/banks';
import ExportAccounts from '../hoc/export/accounts';
import ExportBatches from '../hoc/export/batches';
import BatchCreate from '../hoc/export/batch-create';
import BatchRead from '../hoc/export/batch-read';
import OutgoingTransaction from '../hoc/outgoing/transaction';

const ExportRoutes = {
  path: ROUTES.EXPORT,
  element: <ExportPage />,
  children: [
    {
      element: <ExportBanks />,
      index: true,
    },
    {
      path: ROUTES.EXPORT_BANKS,
      element: <ExportBanks />,
      children: [
        {
          element: <ExportAccounts />,
          index: true,
        },
        {
          path: ROUTES.EXPORT_ACCOUNTS,
          element: <ExportAccounts />,
          children: [
            {
              element: <ExportBatches />,
              index: true,
            },
            {
              path: ROUTES.EXPORT_BATCHES,
              element: <ExportBatches />,
              children: [
                {
                  path: ROUTES.EXPORT_BATCHES_ADD,
                  element: <BatchCreate />,
                },
                {
                  path: ROUTES.EXPORT_BATCHES_READ,
                  element: <BatchRead />,
                },
                {
                  path: ROUTES.EXPORT_BATCHES_READ_OUTGOING,
                  element: <OutgoingTransaction withBackLink />,
                },
                {
                  path: ROUTES.EXPORT_BATCHES_ADD_OUTGOING,
                  element: <OutgoingTransaction withBackLink />,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default ExportRoutes;
